import axios from "~/plugins/axios";
export default {
  getRecipeByProductId(productId) {
    let url = `/p/wp-json/wp/v2/recipepid/${productId}/light`;
    return axios
      .get(url)
      .then(response => {
        return response.data;
      })
      .catch(err => err);
  }
};
